import { Button, Grid, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { MuiDataTable } from './Tabla';
import { EstadoApi } from '../../bussines/entities/EstadoApi.entity';

interface TablaScreenProps {
    columns: any[];
    data: any[];
    lastRevision: string;
    onClick: () => Promise<void> | void;
}

export const TablaScreen: React.FC<TablaScreenProps> = ({ columns, data, lastRevision, onClick }) => {
    return (
        <Grid container margin={0} sx={{ bgcolor: 'white', borderRadius: '15px' }} padding={0}>
            <Grid item lg={10} md={8} sm={6} xs={12}>
                <Typography variant="h5" mt={0.5} textAlign="start" lineHeight={1.1}>Ultima revisión masiva: {lastRevision}</Typography>
            </Grid>
            <Grid item lg={2} md={4} sm={6} xs={12}>
                <Button variant='contained' fullWidth onClick={onClick}>Actualizar Estado</Button>
            </Grid>
            <Grid item xs={12}>
                <MuiDataTable columns={columns} data={data} />
            </Grid>
        </Grid>
    )
}